import { createSlice } from '@reduxjs/toolkit';
import { useSelector, useDispatch } from 'react-redux';
import {
  CashDisbursementApi,
  CashDisbursementApi_extrareducer,
} from './cash-disbursement-journey/index';

const initialState = {
  // isInitialRender: true,
  cashDisbursementApiState: {
    response: {},
    isLoading: false,
    isError: false,
    isSuccess: false,
  },
};

export const CashDisbursementSlice = createSlice({
  name: 'cashDisbursement',
  initialState,
  extraReducers: {
    ...CashDisbursementApi_extrareducer,
  },
});

export function useCashDisbursementStore() {
  const cashDisbursementApiState = useSelector(
    (state) => state.cashDisbursement.cashDisbursementApiState
  );

  const dispatch = useDispatch();

  return {
    cashDisbursementApiState,
    CashDisbursementApi: (payload) => dispatch(CashDisbursementApi(payload)),
  };
}

export const { updateInitialRender } = CashDisbursementSlice.actions;

export default CashDisbursementSlice.reducer;
